import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Card, CardBody, Container, Form, FormGroup, Input , Popover, PopoverBody } from "reactstrap";
import moment from "moment";
import Select, { components } from "react-select";
import { Link } from "react-router-dom";

import DateRangePickerPrimary from "../../../share-components/ui/DateRangePickerPrimary";
import BootstrapTable from "../../../share-components/table/BootstrapTable";
import Breadcrumb from "../../../layout/breadcrumb";
import PaymentsTotalSummary from "./components/PaymentsTotalSummary";

import withReducer from "../../../store/withReducer";
import reportReducer from "../index";

import {
    getFinancesSummarySetting,
    getFinancesPaymentsDetails,
    exportFinancesPaymentsDetails
} from "./store/financesSummarySlice";

import {
    formatter, formatterDecimal
} from "../../../utils/common";

import "./styles.scss";

const PopoverBasicItem = (props) => {
    const {id,btntext,Popoverbody} = props;
    const [popover, setPopover] = useState(false)
    const Toggle = () => setPopover(!popover);
    return (
        <>
            
            <p style={{ cursor: "default" }}>
                {btntext}  
                {Popoverbody && (
                    <i
                        id={"Popover-" + id}
                        className="fa fa-info-circle"
                        style={{ marginLeft: 5, cursor: "pointer" }}
                    ></i>
                )}
            </p>
            
            {Popoverbody && (
                <Popover
                    placement="bottom"
                    isOpen={popover}
                    target={"Popover-" + id}
                    toggle={Toggle}
                    trigger="hover"
                >
                    <PopoverBody>{Popoverbody}</PopoverBody>
                </Popover>
            )}
        </>
    );
};

const PaymentsDetailView = (props) => {

    const financesSummaryState = useSelector(
        ({ report }) => report.financesSummary
    );

    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(window.location.search);


    // Parse dates from URL (accepts ISO or YYYY-MM-DD). If missing set sensible defaults.
    const parseDateParam = (key) => {
        const val = queryParams.get(key);
        if (!val) return null;
        const d = new Date(val);
        if (!isNaN(d.getTime())) return d;
        const m = moment(val, "YYYY-MM-DD", true);
        return m.isValid() ? m.toDate() : null;
    };

    let endDateObj = parseDateParam('end_date');
    let startDateObj = parseDateParam('start_date');

	if (!(queryParams.has('gateway_id') && queryParams.has('gateway')) && (!startDateObj || !endDateObj)) {
		endDateObj = new Date();
		startDateObj = new Date(endDateObj);
		startDateObj.setDate(endDateObj.getDate() - 30);
	}

    const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);
    const [startDate, endDate] = dateRange;

    const [dateWiseReturn, setDateWiseReturn] = useState(queryParams.has('is_date_wise_return') ? queryParams.get('is_date_wise_return') === '1' : true);

    const afterToday = () => {
        return (date) => date.getTime() > new Date().getTime();
    };

    const statuses = [
        { 'id': '', 'name': 'All' },
        { 'id': 0, 'name': 'Normal Orders' },
        { 'id': 1, 'name': 'Test Orders' },
    ];

    const countryTypes = [
        { 'id': 'uk', 'name': 'UK' },
        { 'id': 'europe', 'name': 'Europe' },
        { 'id': 'international', 'name': 'International' },
    ];

    const gateway = queryParams.get('gateway');
    const gatewayId = queryParams.get('gateway_id');
    const partner = queryParams.get('partner');
    const countryType = queryParams.get('country_type');
    const presentmentCurrency = queryParams.get('presentment_currency');

    // presence flags: whether param came in URL
    const hasGatewayIdParam = queryParams.has('gateway_id');
    const hasStartDateParam = queryParams.has('start_date');
    const hasEndDateParam = queryParams.has('end_date');
    const hasDateWiseParam = queryParams.has('is_date_wise_return');
    const hasPartnerParam = queryParams.has('partner');
    const hasGatewayParam = queryParams.has('gateway');
    const hasCountryTypeParam = queryParams.has('country_type');
    const hasPresentmentCurrencyParam = queryParams.has('presentment_currency');

    const defaultPartner = hasPartnerParam ? { 'id': Number(partner), 'name': '' } : null;
    const defaultGateway = hasGatewayParam ? { 'key': gateway, 'name': '' } : null;
    const defaultCountryType = hasCountryTypeParam ? countryTypes.find(item => item.id === countryType) : null;
    const defaultPresentmentCurrency = hasPresentmentCurrencyParam ? { 'id': presentmentCurrency, 'name': '' } : null;

    const [loading, setLoading] = useState(true);
    const [exportBtnDisabled, setExportBtnDisabled] = useState(false);

    const [timer, setTimer] = useState(null);
    const [lastFillters, setLastFillters] = useState(null);
    const [fillterPartner, setFillterPartner] = useState(defaultPartner);
    const [fillterGateway, setFillterGateway] = useState(defaultGateway);
    const [fillterStatus, setFillterStatus] = useState({ 'id': 0, 'name': 'Normal Orders' });
    const [fillterCountryType, setFillterCountryType] = useState(defaultCountryType);
    const [fillterCurrency, setFillterCurrency] = useState(defaultPresentmentCurrency);
    const [filter, setFilter] = useState({
        page: 1,
        pageSize: 10,
        start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
        end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
        partner: hasPartnerParam ? Number(partner) : null,
        country_type: hasCountryTypeParam ? (defaultCountryType ? defaultCountryType.id : null) : null,
        presentment_currency: hasPresentmentCurrencyParam ? presentmentCurrency : null,
        payment_method: hasGatewayParam ? gateway : null,
        is_test_order: fillterStatus ? fillterStatus.id : null,
        is_date_wise_return: hasDateWiseParam ? (queryParams.get('is_date_wise_return') === '1' ? 1 : 0) : 1,
        gateway_id: hasGatewayIdParam ? Number(gatewayId) : null
    });

    const dataMenu = [
        {
            type: 1,
            text: "Finances Summary",
            link: '/report/finances-summary'
        },
        {
            type: 0,
            text: "Payments Details",
        },
    ];


    useEffect(() => {
        dispatch(getFinancesSummarySetting());
    }, [dispatch]);

    const getFinancesDetailsData = () => {
        if (JSON.stringify(filter) == JSON.stringify(lastFillters)) return;

        setLastFillters({ ...filter });
        setLoading(true);

        dispatch(
            getFinancesPaymentsDetails(filter)
        ).then((res) => {
            if (!res.error) {
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        getFinancesDetailsData();
    }, [dispatch, filter]);
    

    useEffect(() => {
        if (financesSummaryState.settings.partners.length > 0 && partner != null && partner.length > 0) {
            const _partner = financesSummaryState.settings.partners.find(item => item.id == partner);
            setFillterPartner(_partner);
        }

        if (financesSummaryState.settings.gateways.length > 0 && gateway != null && gateway.length > 0) {
            const _gateway = financesSummaryState.settings.gateways.find(item => item.key == gateway);
            setFillterGateway(_gateway);
        }

        if (financesSummaryState.settings.currencies.length > 0 && presentmentCurrency != null && presentmentCurrency.length > 0) {
            const _presentmentCurrency = financesSummaryState.settings.currencies.find(item => item.id == presentmentCurrency);
            setFillterCurrency(_presentmentCurrency);
        }
    }, [financesSummaryState.settings.partners, financesSummaryState.settings.gateways, financesSummaryState.settings.currencies]);

    let tableColumns = [
        {
            name: 'Order Name',
            selector: (row) => {
                if (row.partner_id === 23) return row.order_name || <span className="d-flex justify-content-center">-</span>;
                if (row.partner_id === 20) return row.order_name ? <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/gojungo-orders/${row.order_id}`} target="_blank">{row.order_name}</Link> : <span className="d-flex justify-content-center">-</span>;
                const btntext = (
                    <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`} target="_blank">{row.order_name}</Link>
                );
                return row.order_name ? btntext : <span className="d-flex justify-content-center">-</span>;
            },
            left: true,
        },
        {
            name: 'MP Order Date',
            selector: row => row.processed_date,
            left: true,
        },
        {
            name: 'Payment Order Date',
            selector: row => row.payout_transaction_date,
            left: true,
        },
        {
            name: 'Payout Date',
            selector: row => row.payout_date,
            left: true,
        },
        {
            name: 'Partner',
            selector: row => row.partner_name,
            left: true,
        },
        {
            name: 'Transaction Type',
            selector: (row) => {
                return <PopoverBasicItem id={row.transaction_id} Popoverbody={row.informations} btntext={row.transaction_type}/>
            },
            left: true,
        },
        {
            name: 'Payment Amount',
            selector: row => formatter.format(row.gross_amount),
            right: true,
            minWidth: '100px', // column size
        },
        {
            name: 'Commission Amount',
            selector: row => formatter.format(row.total_commission),
            right: true,
            minWidth: '100px', // column size
        },
        {
            name: 'Gateway Fee',
            selector: row => {
                return <span className={row.cur_mp_gateway_fee != row.cur_gateway_fee ? 'text-danger' : ''}>{formatter.format(row.cur_gateway_fee)}</span>
            },
            right: true,
            minWidth: '100px', // column size
        },
        {
            name: 'Gateway Fee (MP)',
            selector: row => {
                return <span className={row.cur_mp_gateway_fee != row.cur_gateway_fee ? 'text-danger' : ''}>{formatter.format(row.cur_mp_gateway_fee)}</span>
            },
            right: true,
            minWidth: '100px', // column size
        },
        {
            name: 'Net Payment',
            selector: row => formatter.format(row.net_amount),
            right: true,
            minWidth: '100px', // column size
        },
        {
            name: 'Status',
            selector: row => row.payout_status,
            center: true,
            minWidth: '100px', // column size
        }
    ];

    if ((fillterGateway ? fillterGateway.key : '') == 'paypal') {
        let tablePayPalColumn = [{
            name: 'Transaction ID',
            selector: row => row.gateway_id,
            left: true,
            minWidth: '100px', // column size
        }];
        tableColumns = [...tableColumns, ...tablePayPalColumn];
    }

    const onPageSizeChange = (newPageSize) => {
        setFilter(prev => ({
            ...prev,
            page: 1,
            pageSize: newPageSize === 'All' ? financesSummaryState.shippingCostSaleDetailsTableRow : newPageSize
        }));
    }

    const onPageChange = (e) => {
        setFilter({ ...filter, page: e })
    }

    const handleCheckboxChangeForDateWiseReturn = () => {
        let isDateWise = !dateWiseReturn;
        setDateWiseReturn(isDateWise);
        setFilter(prev => ({
            ...prev,
            page: 1,
            is_date_wise_return: isDateWise ? 1 : 0
        }));
    };

    const handleOnChangeOrderNo = (e) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(prev => ({
                ...prev,
                page: 1,
                order_no: e.target.value
            }));
        }, 500);
        setTimer(newTimer)
    };

    useEffect(() => {
        setFilter(prev => ({
            ...prev,
            page: 1,
            start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
            end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
            partner: fillterPartner ? fillterPartner.id : null,
            country_type: fillterCountryType ? fillterCountryType.id : null,
            presentment_currency: fillterCurrency ? fillterCurrency.id : null,
            payment_method: fillterGateway ? fillterGateway.key : null,
            is_test_order: fillterStatus ? fillterStatus.id : null,
            is_date_wise_return: dateWiseReturn ? 1 : 0
        }));

    }, [startDate, endDate, dateWiseReturn, fillterPartner, fillterGateway, fillterStatus, fillterCountryType, fillterCurrency]);

    const exportFile = () => {
        if (exportBtnDisabled) return;
        setExportBtnDisabled(true);

        dispatch(
            exportFinancesPaymentsDetails(filter)
        ).then((res) => {
            const link = document.createElement("a");
            link.href = res.payload;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            link.remove();
            setExportBtnDisabled(false);
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: 50,
            border: "none",
        }),
    };

    // Update URL query parameters when any filter changes (no page reload)
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const setOrDelete = (key, value) => {
            if (value === null || value === undefined || value === '') {
                params.delete(key);
            } else {
                params.set(key, String(value));
            }
        };

        setOrDelete('start_date', startDate ? moment(startDate).format('YYYY-MM-DD') : null);
        setOrDelete('end_date', endDate ? moment(endDate).format('YYYY-MM-DD') : null);
        setOrDelete('is_date_wise_return', dateWiseReturn ? 1 : 0);
        setOrDelete('partner', fillterPartner ? fillterPartner.id : null);
        setOrDelete('gateway', fillterGateway ? fillterGateway.key : null);
        // use is_test_order to match filter naming used elsewhere
        setOrDelete('is_test_order', (fillterStatus && fillterStatus.id !== '') ? fillterStatus.id : null);
        setOrDelete('country_type', fillterCountryType ? fillterCountryType.id : null);
        setOrDelete('presentment_currency', fillterCurrency ? fillterCurrency.id : null);

        const queryString = params.toString();
        const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        window.history.replaceState(null, '', newUrl);
    }, [startDate, endDate, dateWiseReturn, fillterPartner, fillterGateway, fillterStatus, fillterCountryType, fillterCurrency]);

    return (
        <Fragment>
            <Breadcrumb title="Payments Details" data={dataMenu} />
            <Container fluid={true} className="finances-summary-page feature-products">
                <Card className="px-3">
                    <Row>
                        <Col md="4">
                            <div className="p-3">
                                <DateRangePickerPrimary
                                    dateRange={dateRange}
                                    dateRangeChange={(date) => {
                                        setDateRange(date);
                                    }}
                                    defaultValue={[startDateObj, endDateObj]}
                                    disabledDate={afterToday()}
                                />
                            </div>
                        </Col>
                        <Col>
                            <div className="float-left">
                                <div className="checkbox checkbox-primary mt-4 mb-3">
                                    <input
                                        id="financesSummaryReturnCalc"
                                        type="checkbox"
                                        checked={dateWiseReturn}
                                        onChange={handleCheckboxChangeForDateWiseReturn}
                                    />
                                    <label htmlFor="financesSummaryReturnCalc">Calculating Date-Wise Returns for Current Date</label>
                                </div>
                            </div>

                            <div className="float-right">
                                <Button
                                    type="button"
                                    color="primary"
                                    className="mt-3"
                                    onClick={() => {
                                        exportFile();
                                    }}
                                    disabled={exportBtnDisabled}
                                >
                                    <i className={exportBtnDisabled ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                                    Export Report
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Row>
                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Partner"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterPartner}
                            onChange={(e) => {
                                setFillterPartner(e);
                            }}
							components={{
								IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterPartner ? null : <components.DropdownIndicator {...props} />;
                                }
							}}
                            isClearable={true}
                            options={financesSummaryState.settings.partners}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Gateway"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.key}
                            value={fillterGateway}
                            onChange={(e) => {
                                setFillterGateway(e);
                            }}
							components={{
								IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterGateway ? null : <components.DropdownIndicator {...props} />;
                                }
							}}
                            isClearable={true}
                            options={financesSummaryState.settings.gateways}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Status"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterStatus}
                            onChange={(e) => {
                                setFillterStatus(e);
                            }}
							components={{
								IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterStatus ? null : <components.DropdownIndicator {...props} />;
                                }
							}}
                            isClearable={true}
                            options={statuses}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Country Type"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterCountryType}
                            onChange={(e) => {
                                setFillterCountryType(e);
                            }}
							components={{
								IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterCountryType ? null : <components.DropdownIndicator {...props} />;
                                }
							}}
                            isClearable={true}
                            options={countryTypes}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Currency"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterCurrency}
                            onChange={(e) => {
                                setFillterCurrency(e);
                            }}
							components={{
								IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterCurrency ? null : <components.DropdownIndicator {...props} />;
                                }
							}}
                            isClearable={true}
                            options={financesSummaryState.settings.currencies}
                        />
                    </Col>

                    <Col md="">
                        <Form>
                            <FormGroup className="m-0">
                                <Input
                                    className="form-control"
                                    type="text"
                                    placeholder="Fillter by Order No / MP Order No / Transaction ID"
                                    onChange={handleOnChangeOrderNo}
                                />
                                <i className="fa fa-search"></i>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>

                <PaymentsTotalSummary financesSummaryState={financesSummaryState} fillterGateway={fillterGateway}/>

                <Card>
                    <CardBody>
                        <BootstrapTable
                            headerColumns={tableColumns}
                            gridData={financesSummaryState.paymentsDetailsLists}
                            noAction
                            progressPending={loading}
                            paginationServer={true}
                            paginationTotalRows={financesSummaryState.paymentsDetailsTableRow}
                            paginationRowsPerPageOptions={[10, 50, 100, 500, 1000]}
                            currentPage={filter.page}
                            perPage={filter.pageSize}
                            onChangePage={onPageChange}
                            onChangeRowsPerPage={onPageSizeChange}
                            size="md"
                        />
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
}

export default withReducer([{ report: reportReducer }])(PaymentsDetailView);